<ng-container *ngIf="hasAccess">
	<ng-content></ng-content>
</ng-container>
